import React, { useEffect, useState } from 'react';
import getCreditAppeal from '../../api/deals/getCreditAppeal';
import Loader from '../Loader/Loader';
import formatNumber from '../../utils/formatNumber';

const MARITAL_STATUS_LABELS = {
  0: 'ÐÐµ ÑÐºÐ°Ð·Ð°Ð½Ð¾',
  1: 'ÐÐµ Ð² Ð±ÑÐ°ÐºÐµ',
  2: 'Ð Ð±ÑÐ°ÐºÐµ',
  3: 'ÐÐ´Ð¾Ð²ÐµÑ / Ð²Ð´Ð¾Ð²Ð°',
  4: 'ÐÑÐ°Ð¶Ð´Ð°Ð½ÑÐºÐ¸Ð¹ Ð±ÑÐ°Ðº',
  5: 'Ð ÑÐ°Ð·Ð²Ð¾Ð´Ðµ',
};

const DOCUMENT_ISSUER_LABELS = {
  MINISTRY_OF_THE_INTERIOR: 'ÐÐÐ',
  MINISTRY_OF_JUSTICE: 'ÐÐ¸Ð½ÑÑÑ',
};

const Field = ({ label, value }) => {
  if (value === undefined || value === null || value === '') return null;
  return (
    <div>
      <p style={{ color: '#8B8B8B' }}>{label}</p>
      <p>{value}</p>
    </div>
  );
};

/**
 * Ð§ÑÐ¾ ÐºÐ»Ð¸ÐµÐ½Ñ ÑÐºÐ°Ð·Ð°Ð» Ð² ÑÐ°Ð¼Ð¾Ð¹ Ð·Ð°ÑÐ²ÐºÐµ Ð½Ð° ÐºÑÐµÐ´Ð¸Ñ (Ð´Ð¾ÑÐ¾Ð´, ÑÐ°Ð±Ð¾ÑÐ°, ÑÐµÐ¼ÐµÐ¹Ð½Ð¾Ðµ Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ
 * Ð¸ Ñ.Ð´.) â Ð´Ð°Ð½Ð½ÑÐµ Ð¾Ð´Ð½Ð¸ Ð½Ð° Ð²ÑÑ Ð·Ð°ÑÐ²ÐºÑ, Ð±Ð°Ð½Ðº Ð½Ðµ Ð²Ð°Ð¶ÐµÐ½, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð±ÐµÑÑÐ¼ JSON Ð¿ÐµÑÐ²Ð¾Ð¹
 * Ð¿Ð¾Ð¿Ð°Ð²ÑÐµÐ¹ÑÑ Ð·Ð°ÑÐ²ÐºÐ¸ ÑÐ°Ð½ÐºÐ° (createCreditAppealRequest, CreditApplication.json).
 */
const LeadCreditApplicationDetails = ({ chunkId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!chunkId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    getCreditAppeal({ chunkId })
      .then((res) => {
        const raw = res.data?.appeals?.[0]?.json;
        if (raw) {
          try {
            setData(JSON.parse(raw));
          } catch {
            setData(null);
          }
        }
      })
      .finally(() => setLoading(false));
  }, [chunkId]);

  if (loading) return <Loader />;
  if (!data) return null;

  const contactPersons = data.contactPersons?.filter((p) => p?.contactPersonLastName) || [];

  return (
    <div style={{ marginBottom: 30 }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16 }}>
        <Field label="ÐÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½ÑÐ¹ Ð²Ð·Ð½Ð¾Ñ" value={data.initialFee ? formatNumber(data.initialFee) : null} />
        <Field label="Ð¡ÑÐ¾Ðº ÐºÑÐµÐ´Ð¸ÑÐ°" value={data.period ? `${data.period} Ð¼ÐµÑ.` : null} />
        <Field label="ÐÐ¾ÑÐ¾Ð´" value={data.incomeMain ? formatNumber(data.incomeMain) : null} />
        <Field label="ÐÐ¾Ð¿. Ð´Ð¾ÑÐ¾Ð´" value={data.additionalIncome ? formatNumber(data.additionalIncome) : null} />
        <Field label="ÐÐµÑÑÐ¾ ÑÐ°Ð±Ð¾ÑÑ" value={data.workName} />
        <Field label="ÐÐ´ÑÐµÑ ÑÐ°Ð±Ð¾ÑÑ" value={data.workAddress} />
        <Field label="Ð¡ÑÐ°ÑÑÑ Ð·Ð°Ð½ÑÑÐ¾ÑÑÐ¸" value={data.workStatus} />
        <Field label="Ð¢ÐµÐ»ÐµÑÐ¾Ð½ ÑÐ°Ð±Ð¾ÑÐ¾Ð´Ð°ÑÐµÐ»Ñ" value={data.companyPhone} />
        <Field label="Ð¡ÐµÐ¼ÐµÐ¹Ð½Ð¾Ðµ Ð¿Ð¾Ð»Ð¾Ð¶ÐµÐ½Ð¸Ðµ" value={MARITAL_STATUS_LABELS[data.MaritalStatus]} />
        <Field label="ÐÐµÑÐ¸" value={data.childrensCount} />
        <Field label="Ð ÐµÐ·Ð¸Ð´ÐµÐ½Ñ Ð Ð" value={data.residentBool === 1 ? 'ÐÐ°' : data.residentBool === 0 ? 'ÐÐµÑ' : null} />
        <Field label="ÐÐµÐ¼ Ð²ÑÐ´Ð°Ð½ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ" value={DOCUMENT_ISSUER_LABELS[data.documentGivedBy]} />
      </div>

      {contactPersons.length > 0 && (
        <div style={{ marginTop: 20 }}>
          <p style={{ color: '#8B8B8B', marginBottom: 8 }}>ÐÐ¾Ð½ÑÐ°ÐºÑÐ½ÑÐµ Ð»Ð¸ÑÐ°</p>
          {contactPersons.map((p, i) => (
            <p key={i}>
              {p.contactPersonFirstName} {p.contactPersonLastName} â {p.contactPersonPhone}
              {p.contactPersonType ? ` (${p.contactPersonType})` : ''}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default LeadCreditApplicationDetails;
